import {FiX} from "react-icons/fi";
import Portal from "../portal";
import React, {useEffect} from "react";

// Počet aktuálně otevřených (visible=true) instancí Modalu. Modaly se můžou vnořit
// (např. formulář příkazu uvnitř "Akce turniketu") — scroll se smí odemknout, až
// je zavřený úplně poslední, ne při zavření libovolného z nich.
let openModalCount = 0;

const Modal = ({visible, accept, close, title, body, footer}) => {
    useEffect(() => {
        if (visible) {
            openModalCount += 1;
            document.body.style.overflow = "hidden";
            return () => {
                openModalCount = Math.max(0, openModalCount - 1);
                if (openModalCount === 0) {
                    document.body.style.overflow = "unset";
                }
            };
        }
    }, [visible]);
    if (!visible) return null;

    return (
        <Portal selector="#portal">
            <div
                style={{position: "fixed", inset: 0, background: "rgba(15,23,42,0.45)", zIndex: 45}}
                onClick={close}
            />
            <div style={{position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50, padding: "16px", pointerEvents: "none"}}>
                <div
                    style={{background: "#fff", borderRadius: "12px", boxShadow: "0 8px 32px rgba(15,23,42,0.14)", width: "100%", maxWidth: "840px", maxHeight: "calc(100vh - 80px)", display: "flex", flexDirection: "column", pointerEvents: "auto"}}
                    onClick={e => e.stopPropagation()}
                >
                    {/* header */}
                    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid #e2e8f0", flexShrink: 0}}>
                        <h3 style={{margin: 0, fontSize: "16px", fontWeight: 700, color: "#1e293b"}}>{title}</h3>
                        <button
                            onClick={close}
                            style={{display: "flex", alignItems: "center", justifyContent: "center", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", padding: "4px", borderRadius: "6px", lineHeight: 1}}
                        >
                            <FiX size={18}/>
                        </button>
                    </div>

                    {/* body */}
                    <div style={{padding: "16px 20px", overflowY: "auto", flex: 1}}>
                        {body}
                    </div>

                    {/* footer */}
                    {footer && (
                        <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px", padding: "12px 20px", borderTop: "1px solid #e2e8f0", flexShrink: 0}}>
                            {footer}
                        </div>
                    )}
                </div>
            </div>
        </Portal>
    );
};

export default Modal
